/**
 * Measure units machines
 */
export const MACHINE_CODES = {
  jumbo: 'JMB',
  manitou: 'MNT',
  scoop: 'SCOP',
  lhd: 'LHD',
  acunador: 'ACU',
  roboshot: 'ROB',
  truck: 'TRU',
  train: 'TEN'
}
